import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { Roles } from '../../features/selfservice/roleAssignments/data'
import i18n from '../../utils/i18n'

export const RoleFilterTemplate = (options: any, roles?: Roles) => {
  if (!options || !roles) return null

  const roleOptions = roles?.map(role => role.name)

  return (
    <Dropdown
      value={options.value}
      options={roleOptions}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      className="p-column-filter"
      placeholder={i18n.t(
        'roleAssignments.table.columns.role.filterPlaceholder',
      )}
    />
  )
}
